import { GET_EVENT_ELIGIBLE_MEMBERS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_EVENT_ELIGIBLE_MEMBERS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
